module.exports = "/files/3feea89a0dacb729bff022c2a2b8668b.pdf";